import React from "react";
import "./ContactMe.css";
import SendMail from "./SendMail/SendMail";
export default function ContactMe() {
  return (
    <div id="ContactMe" className="contactMe-container">
      <div className="header-container">
        {" "}
        <h2>
          <span className="primary-text">Contact Me</span>
        </h2>{" "}
        <span style={{ color: "grey" }}>Lets Stay in Touch</span>
        <span> &#8594; &#9827; &#8592;</span>
      </div>
      <div className="contactMe-box">
        <div className="contactMe-sidebar">
          <h1>Get in Touch 📧</h1>
          <div className="colz">
            <div className="colz-icon">
              <a
                href="https://www.facebook.com/people/Kokonod-Ray/pfbid02hgTK8UF7SAZCnod7Z4dTFWmLdb75xtuD7t7AjAp2RgoSRoDiC4NX7EzdZSZXLAXDl/"
                class="fa-brands fa-facebook"
                style={{ color: "blue" }}
              ></a>
              <a
                href="https://twitter.com/kokonod_ray?t=hA0RUAAGwCtMpKqatmlCuw&s=08"
                class="fa-brands fa-twitter"
                style={{ color: "lightblue" }}
              ></a>
              <a
                href="https://www.instagram.com/k_o_k_o_007/?hl=en"
                class="fa-brands fa-instagram"
                style={{ color: " #a4137e" }}
              ></a>
              <a
                href="https://www.linkedin.com/in/kokonod-ray-b161431a3/"
                class="fa-brands fa-linkedin "
                style={{ color: "#124191" }}
              ></a>
            </div>
          </div>
          <span style={{ color: "gray" }}>Send Your Email Here!</span>
          <div className="contactMe-img"></div>
        </div>
        <div className="contactMe-sendMail">
          <SendMail />
        </div>
      </div>
    </div>
  );
}
